var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluttBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 483.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.54,162.65h41.25c.76,0,1.52-.29,2.1-.87l59.52-59.52c.54-.54.87-1.28.87-2.1,0-1.64-1.33-2.97-2.97-2.97l-100.69-.12-.08,65.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.85,327.46c33.05,0,59.85.43,59.85.96s-26.8.96-59.85.96-59.85-.43-59.85-.96,26.8-.96,59.85-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.15,327.46c33.05,0,59.85.43,59.85.96s-26.8.96-59.85.96-59.85-.43-59.85-.96,26.8-.96,59.85-.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.87,349.37c-3.83,3.12-8.91,4.81-15.06,4.81-10.79,0-16.94-6.95-19.88-10.34l5.08-5.79c3.12,4.19,8.91,8.82,15.6,8.82s12.03-3.83,12.03-10.34-6.86-8.91-9.98-10.16c-3.21-1.25-7.49-2.94-9.81-4.1-1.34-.62-3.92-1.96-6.15-4.37-2.23-2.32-4.01-5.71-4.01-10.7s2.32-9.09,5.62-11.86c3.39-2.85,8.2-4.55,14.17-4.55,10.07,0,15.96,6.15,17.65,7.93l-4.55,5.88c-3.03-3.21-7.49-6.6-13.55-6.6s-10.7,2.85-10.7,8.56,4.19,7.84,7.93,9.36l11.32,4.72c1.16.54,4.9,2.59,6.95,4.99,1.96,2.41,3.74,5.71,3.74,10.34,0,5.35-2.41,10.07-6.42,13.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.27,
    y: 291.6,
    width: 8.65,
    height: 61.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.61 298.82 230.11 298.82 230.11 319.33 254.09 319.33 254.09 326.55 230.11 326.55 230.11 353.11 221.47 353.11 221.47 291.6 255.61 291.6 255.61 298.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.57,353.11h-9.63l-6.33-16.05h-26.39l-6.33,16.05h-9.09l25.05-61.69h7.58l25.14,61.69Zm-18.36-23.27l-10.79-27.63-10.79,27.63h21.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "348.58 298.82 331.29 298.82 331.29 353.11 322.64 353.11 322.64 298.82 305.26 298.82 305.26 291.6 348.58 291.6 348.58 298.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.95 387.17 78.75 387.17 78.75 422.71 120.32 422.71 120.32 435.23 78.75 435.23 78.75 481.28 63.76 481.28 63.76 374.65 122.95 374.65 122.95 387.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "192.65 481.28 140.1 481.28 140.1 374.65 155.09 374.65 155.09 468.46 192.65 468.46 192.65 481.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.21,437.7c0,13.29-1.24,23.8-8.5,32.45-7.26,8.35-17.93,12.98-31.99,12.98s-24.88-4.64-31.99-12.98c-7.42-8.65-8.65-19.16-8.65-32.45v-63.05h15.15v61.66c0,8.96.15,17.62,4.94,23.95,4.33,5.87,11.28,9.43,20.55,9.43s16.07-3.55,20.55-9.43c4.79-6.34,4.95-15.14,4.95-23.95v-61.66h14.99v63.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.38 387.17 340.39 387.17 340.39 481.28 325.4 481.28 325.4 387.17 295.27 387.17 295.27 374.65 370.38 374.65 370.38 387.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "447.8 387.17 417.82 387.17 417.82 481.28 402.83 481.28 402.83 387.17 372.69 387.17 372.69 374.65 447.8 374.65 447.8 387.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m371.54,57.41L314.99.87c-.58-.58-1.34-.87-2.1-.87h0s-95.31,0-95.31,0h-56.73c-1.64,0-2.97,1.33-2.97,2.97v263.86c0,.76.29,1.52.87,2.1,1.16,1.16,3.04,1.16,4.2,0l62.49-62.49c.54-.54.87-1.28.87-2.1l.08-141.86h143.05c1.64,0,2.97-1.33,2.97-2.97,0-.82-.33-1.56-.87-2.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluttBranco);
export default __webpack_public_path__ + "static/media/Flutt - Branco.05f34ab03c4ed6d73c89743700aab267.svg";
export { ForwardRef as ReactComponent };